import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../../style/contactPage/contactpage.scss";
import Image from "react-bootstrap/Image";
import { Row, Col } from "react-bootstrap";
import MapImg from '../../assets/contact_mapImg.jpg'
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import {
  contact_follow_us_text,
  contact_enquiry_subtitle,
  contact_subnav_content1,
  contact_enquiry_form_submit_btn,
} from "../../utility/constants";

function ContactEnquiry() {
  return (
    <>
      <div>
        <Row className="contact-enquiry-div d-flex">
          <Col
            lg={6}
            md={12}
            className=" text-black contact-map-div  d-flex justify-content-end align-items-end "
          >
            <div className="contact-map-content">
              <div>
                <p>{contact_follow_us_text}</p>
              </div>
              <div className="vl"></div>

              <div className="contact-social-icon">
                <div>
                  <FontAwesomeIcon
                    icon={faFacebookF}
                    className="contact-icon-img"
                  />
                </div>

                <div style={{ marginTop: "10px" }}>
                  <FontAwesomeIcon
                    icon={faLinkedinIn}
                    className="contact-icon-img"
                  />
                </div>
                <div style={{ marginTop: "10px" }}>
                  <FontAwesomeIcon
                    icon={faInstagram}
                    className="contact-icon-img"
                  />
                </div>
              </div>
            </div>

            <Image src={MapImg} className="enquiry-map-img" fluid />
          </Col>
          <Col className=" text-black enquiry-form">
            <div>
              <h2>{contact_subnav_content1}</h2>
              <p>{contact_enquiry_subtitle}</p>

              <Form>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Control
                    type="email"
                    placeholder="Full name"
                    className="form-fields"
                  />
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Control
                    type="email"
                    placeholder="Your email"
                    className="form-fields"
                  />
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Control
                    type="email"
                    placeholder="Phone number"
                    className="form-fields"
                  />
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    as="textarea"
                    placeholder="Message"
                    rows={3}
                    className="form-fields form-message"
                  />
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  className="form-submit-btn"
                >
                  {contact_enquiry_form_submit_btn}
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
        <div>
          <hr class="hr-solid-line"></hr>
        </div>
      </div>
    </>
  );
}

export default ContactEnquiry;
